import { render } from "./TrainingPage.vue?vue&type=template&id=ba4f9304&scoped=true"
import script from "./TrainingPage.vue?vue&type=script&lang=js"
export * from "./TrainingPage.vue?vue&type=script&lang=js"

import "./TrainingPage.vue?vue&type=style&index=0&id=ba4f9304&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba4f9304"]])

export default __exports__
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCheckbox});
